import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { patientActions } from '@libs/store';
import { chartingActions } from './charting.actions';

@Injectable({ providedIn: 'root' })
export class ChartingEffects {
  private readonly actions$ = inject(Actions);

  public loadTeeth$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(chartingActions.paramsChanged),
      map(({ siteId, patientId, examCount, silentReload }) =>
        patientActions.onLoadTeeth({ siteId, patientId, examCount, silentReload: false }),
      ),
    );
  });

  public resetLastToothPosition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(chartingActions.paramsChanged),
      map(() => chartingActions.lastToothPositionChanged({ toothPosition: undefined })),
    );
  });
}
